





























































import { defineComponent } from "@vue/composition-api";
import BaseIcon from "@/components/BaseIcon";
import BasePage from "@/components/BasePage";
import PageTitle from "@/components/PageTitle";

export default defineComponent({
  name: "PagePushNotificationsHowTo",
  components: { BaseIcon, PageTitle, BasePage },
});
